import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";

const LoadingImage = ({ src, alt, className }) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div>
      {isLoading ? (
        <div style={{ display:"flex",justifyContent:"center",alignItems:"center",width: "300px",height:"300px" }}>
          <Spinner
            animation="border"
            role="status"
            style={{
              color: "gray",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <img src={src} alt={alt} className={className} loading="lazy" />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default LoadingImage;
